import { Thermometer, Wind, Gauge, Waves } from "lucide-react";
import { fmtTime } from "../lib/api";

const compass = (deg) => ["N", "NE", "E", "SE", "S", "SW", "W", "NW"][Math.round(deg / 45) % 8];

function Cell({ icon: Icon, label, value, testId }) {
  return (
    <div className="bg-[#1E1E24] border-2 border-[#27272A] p-3" data-testid={testId}>
      <div className="flex items-center gap-1 text-[10px] font-bold uppercase tracking-widest text-zinc-400">
        <Icon size={12} /> {label}
      </div>
      <div className="mt-1 font-display text-lg leading-tight">{value}</div>
    </div>
  );
}

export function WeatherGrid({ w, tide, prefix = "weather" }) {
  if (!w) return <p className="text-sm text-zinc-500" data-testid={`${prefix}-none`}>No weather recorded.</p>;
  const tideValue = !tide?.available
    ? "No tide data"
    : `${tide.height_ft ?? "–"} ft ${tide.trend || ""}`.trim();
  return (
    <div className="grid grid-cols-2 gap-3">
      <Cell icon={Thermometer} label={w.description ? `Temp · ${w.description}` : "Temp"} value={w.temp_f != null ? `${Math.round(w.temp_f)}°F` : "–"} testId={`${prefix}-temp`} />
      <Cell icon={Wind} label="Wind" value={w.wind_mph != null ? `${Math.round(w.wind_mph)} mph${w.wind_dir_deg != null ? ` ${compass(w.wind_dir_deg)}` : ""}` : "–"} testId={`${prefix}-wind`} />
      <Cell icon={Gauge} label={`Pressure ${w.pressure_trend || ""}`} value={w.pressure_inhg ? `${w.pressure_inhg} inHg` : "–"} testId={`${prefix}-pressure`} />
      <Cell icon={Waves} label={tide?.next_event ? `Next ${tide.next_event.type} ${fmtTime(tide.next_event.time)}` : "Tide"}
        value={tideValue} testId={`${prefix}-tide`} />
    </div>
  );
}
